import { Phone, Instagram, MapPin, MessageCircle } from "lucide-react";
import {
  PHONE_DISPLAY,
  PHONE_TEL,
  ADDRESS,
  INSTAGRAM_HANDLE,
  INSTAGRAM_URL,
  waLink,
  DEFAULT_WA_MESSAGE,
} from "../data/content";
import { LogoMark } from "./Logo";

export const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-[#060C1E] border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid md:grid-cols-3 gap-10">
          <div>
            <div className="flex items-center gap-3">
              <LogoMark size="sm" />
              <span className="font-display font-extrabold text-white tracking-tight">
                EFEITO <span className="text-sky-400">NOVO</span>
              </span>
            </div>
            <p className="mt-4 text-sm text-slate-400 leading-relaxed max-w-xs">
              Limpeza profissional que renova tudo. Sofás, colchões, carpetes,
              telhados e terraços no Grande Porto.
            </p>
          </div>

          <div>
            <h4 className="font-display text-sm font-bold uppercase tracking-widest text-slate-300">
              Contactos
            </h4>
            <ul className="mt-4 space-y-3 text-sm text-slate-400">
              <li>
                <a
                  href={PHONE_TEL}
                  data-testid="footer-phone"
                  className="inline-flex items-center gap-2.5 hover:text-sky-300 transition-colors"
                >
                  <Phone className="h-4 w-4 text-sky-400" /> {PHONE_DISPLAY}
                </a>
              </li>
              <li>
                <a
                  href={INSTAGRAM_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-instagram"
                  className="inline-flex items-center gap-2.5 hover:text-sky-300 transition-colors"
                >
                  <Instagram className="h-4 w-4 text-sky-400" /> {INSTAGRAM_HANDLE}
                </a>
              </li>
              <li className="inline-flex items-start gap-2.5" data-testid="footer-address">
                <MapPin className="h-4 w-4 text-sky-400 mt-0.5" /> {ADDRESS}
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-display text-sm font-bold uppercase tracking-widest text-slate-300">
              Orçamento rápido
            </h4>
            <p className="mt-4 text-sm text-slate-400 leading-relaxed">
              Resposta em minutos, sem compromisso.
            </p>
            <a
              href={waLink(DEFAULT_WA_MESSAGE)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp-button"
              className="mt-4 inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#1eb857] text-[#06281a] font-bold text-sm px-6 py-3 rounded-full transition-colors"
            >
              <MessageCircle className="h-4 w-4" />
              Abrir WhatsApp
            </a>
          </div>
        </div>

        <div className="mt-12 border-t border-white/5 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p
            data-testid="footer-values"
            className="font-display text-xs font-bold tracking-[0.35em] uppercase text-sky-300/80"
          >
            Qualidade • Confiança • Resultados
          </p>
          <p className="text-xs text-slate-500">
            © {new Date().getFullYear()} Efeito Novo. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};
